export enum Skin {
	Default = 'skin-default',
	Dark = 'skin-dark',
	Light = 'skin-light'
}
